import React, { useRef } from 'react';
import { Input } from '../../common/input.component';
import { AsYouType } from 'libphonenumber-js';
import { parsePhoneNumberFromString } from 'libphonenumber-js/min';

type PhoneInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  title?: string;
  required?: boolean;
};

export function formatPhoneNumber(phoneString: string | undefined): string {
  if (!phoneString) return '';
  const phoneNumber = parsePhoneNumberFromString('+' + phoneString);
  if (phoneNumber) {
    return phoneNumber.formatInternational();
  }
  return phoneString;
}

export const PhoneInput = ({
  value,
  onChange,
  placeholder = '+7',
  disabled,
  className,
  title,
  required,
}: PhoneInputProps) => {
  const phoneInputRef = useRef<HTMLInputElement>(null);

  function handlePhoneChange(e: React.ChangeEvent<HTMLInputElement>) {
    const input = e.target;
    const cursorPos = input.selectionStart ?? 0;
    const rawValue = input.value;

    const cleaned = rawValue.startsWith('+')
      ? rawValue.replace(/[^\d+]/g, '')
      : '+' + rawValue.replace(/\D/g, '');

    const formatter = new AsYouType();
    const formatted = formatter.input(cleaned);

    const diff = formatted.length - rawValue.length;

    onChange(formatted);

    setTimeout(() => {
      const el = phoneInputRef.current;
      // react-input-mask routes the ref through its wrapper component, which
      // does not expose setSelectionRange — fall back to browser default
      // positioning rather than crash inside an unrecoverable setTimeout.
      if (el && typeof el.setSelectionRange === 'function') {
        const newPos = Math.max(cursorPos + diff, 0);
        el.setSelectionRange(newPos, newPos);
      }
    }, 0);
  }

  let country: string | undefined;
  try {
    const phoneNumber = parsePhoneNumberFromString(value);
    country = phoneNumber?.country;
  } catch {
    country = undefined;
  }
  return (
    <div className={className}>
      <Input
        ref={phoneInputRef}
        title={title}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        value={value}
        mask="+7 (999) 999-99-99"
        onChange={handlePhoneChange}
      />
      {country && (
        <small className="text-muted d-block mt-1">Страна: {country}</small>
      )}
    </div>
  );
};
